import { mapActions, mapGetters, mapMutations } from "vuex";
import { dynamicHead } from "../../mixins/dynamic-head";

export default {
    name: "public-offer",
    data() {
        return {
            content: "",
        };
    },
    mixins: [dynamicHead],
    components: {},
    computed: {
        ...mapGetters({
            allPagesList: "setting/allPagesList",
        }),
    },
    created() {
        console.log(1);
    },
    mounted() {
        this.getAllPages().then(() => {
            this.allPagesList.forEach(el => {
                if (el.slug === "public_offer") {
                    this.content = el;
                }
            });
        });
    },
    methods: {
        ...mapActions({
            getCategories: "setting/GET_CATEGORIES_MENU",
            getAllPages: "setting/GET_ALL_PAGES",
            getSeoData: "setting/GET_SEO_DATA",
        }),
        ...mapMutations({}),
    },
    destroyed() {},
};
